module.exports = __webpack_public_path__ + "static/media/iPad.ad39957e.svg";